import { Box, Typography } from '@mui/material';
import { bagStatuses } from '@/constants/Bag';

export const BinLevelField = record => {
    if (!record) return null;

    const isSealed = record.status === bagStatuses.collected || record.status === bagStatuses.error || record.status === bagStatuses.manually_closed;

    return (
        <Box sx={isSealed ? { width: 'max-content', gap: '4px' } : {}}>
            <Typography variant='body2' sx={isSealed ? { fontWeight: 600 } : {}} className={isSealed ? '' : 'gray'}>
                {record.binLevel ? `${record.binLevel} %` : '—'}
            </Typography>
        </Box>
    );
};
